import React from 'react';
import Order from './Order';
import { connect } from 'react-redux'

class SelectedOrderTags extends React.Component {
    render() {
        const { orderTags, orderQuantity } = this.props;
        const safeOrderQuantity = Number(orderQuantity) || 1;

        if (!orderTags || orderTags.length === 0) return null;

        return (
            <div className="selectedOrderTags">
                {orderTags.map(({ tag, tagName, price, quantity }) => {
                    const safePrice = Number(price) || 0;
                    const safeQuantity = Number(quantity) || 1;
                    const lineTagPrice = safePrice * safeQuantity * safeOrderQuantity;

                    return (
                        <div
                            className="selectedOrderTagChip"
                            key={tag + tagName}
                            style={{ borderColor: this.getColor(tag) }}
                        >
                            {safeQuantity > 1 &&
                                <span className="selectedOrderTagQuantity">
                                    {safeQuantity}x
                                </span>
                            }

                            <span className="selectedOrderTagName">
                                {tag}
                            </span>

                            {safePrice > 0 &&
                                <span className="selectedOrderTagPrice">
                                    + {lineTagPrice.toFixed(2)}
                                </span>
                            }
                        </div>
                    );
                })}
            </div>
        );
    }

    getColor = (tag) => {
        if (this.props.orderTagColors) {
            var result = this.props.orderTagColors[tag];
            if (result) return result;
        }

        return '#90caf9';
    }
}

const mapStateToProps = state => ({
    orderTagColors: state.menu.get('orderTagColors')
})

export default connect(
    mapStateToProps
)(SelectedOrderTags)



// WEBPACK FOOTER //
// ./app/components/SelectedOrderTags.jsx